export const JWT_ACCESS_TOKEN = "jwtAccessToken";
export const CONVERSATION_TYPE = "ConversationType";
export const CONVERSATION_TYPE_ADMIN = "ConversationTypeAdmin";
export const LANGUAGE = "language";
export const USER_PANEL = "UserPanel";
export const CONDENSED = "Condensed";
export const EN = "en";
export const SR = "sr-Latn";
export const SRCiryl = "sr-Cyrl";
export const IT = "it";
export const OPEN = "true";
export const CLOSE = "false";
